export default () => ({
  list: {},
  years: [],
})
